import { css } from '@emotion/react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '~/common/layouts/Sidebar.tsx';
import { COLORS } from '~/configs/theme.ts';
import UserDetailModal from '~/features/user/components/UserDetailModal';

function BaseLayout() {
  return (
    <>
      <div css={styles.baseLayout}>
        <Sidebar />

        <main css={styles.main}>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <UserDetailModal />
    </>
  );
}

const styles = {
  baseLayout: css`
    display: flex;
    width: 100vw;
    height: 100vh;
    background: ${COLORS.GRAY['75']};
  `,

  main: css`
    flex: 1;
    min-width: 0;
    height: 100vh;
    overflow: hidden;
  `,
};

export default BaseLayout;
